<template>
    <div class="job-detail" id="example-content" v-if="detail">
        <div class="job-detail-top">
          <div class="contentWidth flexBetween">
            <div class="shrink" style="width: 70%;">
              <div class="flex job-detail-top-name"> 
                <img :src="detail.avatarUrl" alt="">
                <div>
                    <div class="flex job-detail-top-name-hot flexCentet">
                        <p v-show="detail.nameCn" class="">{{ detail.nameCn }}</p>
                        <img src="../../assets//images/newicon/icons/hotCompany.png" 
                          style="width: 76px;height: 32px;" alt="" 
                          v-if="detail.isHot">
                    </div>
                    <p>
                        <span>{{detail.industryTypeName}} / </span>
                        <span>{{detail.financingTypeName}} /</span>
                        <span>{{detail.companyTypeName}}</span>
                    </p>
                </div>
              </div>
              <!-- <div class="flex job-detail-top-label">
                <Btns></Btns>
                <Btns></Btns>
                <Btns></Btns>
                <Btns></Btns> 
              </div> -->
            </div>
            <div class="shrink job-detail-top-opeart flexColumn" >
              <div class="opeart-counts"><span>{{detail.positionCounts}}</span> 个在招职位</div>
              <div class="flex">
                <p class="flex itemsCenter" @click="goMyresume"> <img src="../../assets/images/newicon/edit.png" alt=""> 填写在线简历</p>
                <p class="flex itemsCenter" @click="goMyresume"> <img src="../../assets/images/newicon/batchfolding.png" alt="">上传附件简历</p>
              </div>
            </div>
          </div>
        </div>
        <div class="job-detail-main contentWidth">
          <div class="flex cards-tabs boxShadow" >
              <div :class="currentTab === item.id ?'active':''" 
                v-for="item in tabs" :key="item.id"
                @click="handleTabChange(item.id)">
                {{ item.name }}
              </div>
          </div>
          <company-info v-if="currentTab===1" 
            :datas="detail" 
            :imgList="imgList"
            @checkCompanyJob="checkCompanyJob">
          </company-info>
          <jobs-info  v-else
            :datas="position" 
            :pagination="pagination"
            :pageIndex="positionQueryData.pageIndex"
            @upJobsearch="upJobsearch"
            @updateFavorite="updateFavorite"
            @updateDelivery="updateDelivery"
            @updatePage="updatePage">
          </jobs-info>

        </div>
    </div>
    <prompt v-else></prompt>
    
  </template>
  
  <script>
  import { mapActions, mapState,mapGetters } from "vuex";
  import CompanyInfo from './components/infos.vue';
  import JobsInfo from './components/jobs.vue';
  import Btns from '../../components/Btn.vue'

  export default {
    components: {CompanyInfo,JobsInfo,Btns},
    name: "companyDetail",
    data() {
      return {
        companyId: "", //公司ID
        detail: null, //详情数据
        currentTab:1,
        tabs:[{id:1,name:"公司主页"},{id:2,name:"招聘职位"}],
        imgList:[], //公司主页，相册图片
        
        position:[],//职位列表
        pagination:null,

        positionQueryData:{
          cityCode:"",//城市编码
          industryType:"", //行业类型
          workExperience:"",//工作经验
          qualificationsType:'', //学历
          name:'',
          pageIndex: 1,
          pageSize: 10,
        },
      };
    },
    computed: {
      ...mapGetters(["isLogin"]),
      ...mapState({
        shlefInfo: state => state.user.info //个人信息
      })
    },
    async created() {
      this.companyId = this.$route.query.id;
      await this.getDetail(); //公司详情
      await this.getPositionArea(); //工作城市
      await this.getList();  //公司职位列表
      await this.getCompanyJob(this.companyId);  //根据公司查询职位类型
    },
    methods: {
      ...mapActions([
        "getCompanyDetail",
        "getPositionArea",
        "getSessionPosition",//某公司下的所有职位
        "addFavorite",
        "deleteFavorite",
        "getCompanyJob"
      ]),
      //获取某公司下的所有职位列表
      async getList() {
        const res = await this.getSessionPosition({
          ...this.positionQueryData,
          debug: true,
          companyId: this.companyId,
        });
        if (res) {
          this.position = res.data;
          this.pagination = res.pagination;
        }
      },
      //根据查询条件查询职位列表
      upJobsearch(data){
        for(let key in data){ 
          this.positionQueryData[key] = data[key]
        }
        this.positionQueryData.pageIndex=1;
        this.getList();
      },
      
      //公司主页/招聘职位相互切换
      async handleTabChange(id){
        this.currentTab=id;
      },

      //公司主页---》查看全部职位
      checkCompanyJob(){
        this.currentTab=2;
        this.positionQueryData.pageIndex=1;
        this.getList();
      },
      //职位的收藏与取消
      async updateFavorite(id,collect){
        if(this.isLogin){
          let idx = this.position.findIndex(item=>item.id === id)
          if(collect){ //取消收藏
            const res = await this.deleteFavorite(id);
            if (res) {
              this.position[idx].favorite = false;
              this.$message({
                message: "取消收藏!",
                type: "success"
              });
            }else {
              this.$message({
                message: res.message,
                type: "warning"
              });
            }
          }else{ //收藏
            const res = await this.addFavorite(id);
            if (res && res.code == 200) {
              this.position[idx].favorite = true;
              console.log(this.position);
              this.$message({
                message: "收藏成功!",
                type: "success"
              });
            } else {
              this.$message({
                message: res.message,
                type: "warning"
              });
            }
          }
        }else{
            return this.$message.warning("请先登陆！");
        }
      },

      //更新内推情况
      updateDelivery(id){
        let idx = this.position.findIndex(item=>item.id === id);
        this.position[idx].delivery = true;
      },
      
      //页码改变请求数据
      async  updatePage(e){
        this.positionQueryData.pageIndex=e;
        await this.getList();
      },

      //填写在线简历
      goMyresume() {
        if (!this.isLogin) {
          this.$router.push("/login");
        } else {
          this.$router.push("/myresume");
        }
      },
     
      // 获得详情数据
      async getDetail() {
        const res = await this.getCompanyDetail(this.companyId);
        this.detail = res;
        for(let key in res.companyAlbumInfoList){
          this.imgList.push(res.companyAlbumInfoList[key].url)
        }
      },
    }
  };
  </script>
  
  <style lang="less" scoped>
  .linkTop {
    width: 100%;
    font-size: 14px;
  }
  .job-detail {
    background: linear-gradient(360deg, #F9FBFF 0%, #DCEAFF 100%);
    padding-bottom: 30px;
    &-top{
      height: 238px;
      background: url('../../assets/images/newicon/jobDetailTopBg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding-top: 60px;
      margin-bottom: 30px;
      .flexBetween{
        flex-wrap: nowrap;
        align-items: flex-start;
      }
      &-name{
        margin-bottom: 10px;
        img{
            width: 80px;
            height: 80px;
            margin-right: 14px;
            border-radius: 6px;
            overflow: hidden;
        }
        p{
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 40px;
          
          span{
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.5);
            line-height: 30px;
          }
        }
        &-hot{
            img{
                width: 76px;
                height: 32px;
                margin-left: 8px;
            }
        }
      }
    
      &-label{
        padding-top: 10px;
        .btn{
          background: #fff;
          opacity:.5;
        }
      }
      &-opeart{
        align-items: flex-end;
        div{
          cursor: pointer;
          
        }
        p{
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          padding-left: 20px;
          img{
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
        }
        .opeart-counts{
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          padding-bottom: 10px;
          span{
            font-size: 36px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #FF8A16;
          }
        }
      }
    }
    &-main{
      align-items: flex-start;
      .cards-tabs{
        background: #fff;
        padding: 14px 20px;
        border-radius:  6px 6px 0 0;
        border-bottom: 1px solid #D8D8D8;
        // margin-bottom: 20px;
        cursor: pointer;
         div{
          margin-right: 30px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51,51,51,0.5);
         }
         .active{
          color: #287CF3;
         }
      }
    }
  }

  </style>
  